import { ref, computed, onMounted } from "vue";
import { defineStore } from "pinia";

export const useGlobalStore = defineStore("global", () => {
  const uid = ref<number | null>(null);
  const email = ref("");

  onMounted(() => {
    const uidStor = window.localStorage.getItem("game-uid");
    if (uidStor) {
      uid.value = +uidStor;
    }
  });
  return { uid, email };
});
